import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import InsightsHero from '@/components/sections/insights/InsightsHero'
import InsightsServices from '@/components/sections/insights/InsightsServices'
import InsightsPricing from '@/components/sections/insights/InsightsPricing'
import InsightsContact from '@/components/sections/insights/InsightsContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Insights() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'Web Analytics', description: 'Custom event tracking, GA4 implementation, and qualitative analysis so you know exactly what works.', path: '/insights' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Insights', path: '/insights' }])} />
      <Navbar />
      <main>
        <InsightsHero />
        <InsightsServices />
        <InsightsPricing />
        <InsightsContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
